<template>
  <div id="login">
      <div class="lleft">
          <div class="logo" >
                <img src="@/assets/logo2.png"  @click="$router.push('/')">
                <div>欢迎访问智能医学科研方案设计平台</div>
           </div> 
           <div class="copy">CopyRight 2012-2025 All Right Reserved 天创明达CreateMed </div>
      </div>
      <div class="lright">
            <div class="rightbox">
                <div class="tit">欢迎，请登录</div>
                <div  class="mt_30 dlfont">用户名：</div>
                <el-input placeholder="请输入用户名" class="inp" v-model="form.username"></el-input>
                 <div  class="mt_30 dlfont">密码：</div>
                <el-input placeholder="请输入密码" type="password" class="inp" v-model="form.password"></el-input>
                <el-button class="logbtn" type="primary" @click="loginclick"> 登录</el-button>
                <div class="mt_20 flex">
                    <div class="flex-1 linkfont" @click="$router.push('/register')">注册账号</div>
                    <div class="linkfont" @click="dialogVisible=true">忘记密码</div>
                </div>  
            </div>
      </div>

      <el-dialog
        title="找回密码" 
        :visible.sync="dialogVisible"
        width="500px">
        <div class="zhmmdiv">
              <div class="tipfont">请输入注册时邮箱 </div> 
              <el-input placeholder="请输入注册时邮箱" class="zhmm" v-model="email"></el-input>
                <el-button type="primary" class="zhmmbtn" @click="zhmm">找回密码</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible2"
        width="500px">
        <div class="zhmmdiv">
              <div class="tipfont">邮件已发送到您的邮箱，请在邮件中点击链接 </div> 
                <el-button type="primary" class="zhmmbtn" @click="dialogVisible2=false">好的</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { login,findPasswordByEmail } from "@/api/index.js"
export default {
  name: "Login",
  data() {
    return {
      form:{
        username:'',
        password:''
      },
      email:'',
      dialogVisible:false,
      dialogVisible2:false
    }
  },
  methods:{
    loginclick(){
       if(this.form.username==''){
          this.$message.error('请输入账号');
          return
       }
        if(this.form.password==''){
          this.$message.error('请输入密码');
          return
       }
       login(this.form).then(res=>{
            if(res.code==1){
                  this.$message({
                    message: '登录成功',
                    type: 'success'
                  });
                  this.$store.commit("login",res.data);
                  this.$router.push('/create')
            }
            
       })
    },
    zhmm(){
      if(this.email==''){
        this.$message.error('请输入注册时邮箱');
        return
      }
      findPasswordByEmail({email:this.email}).then(res=>{
         if(res.code==1){
           this.dialogVisible=false;
      this.dialogVisible2=true;
         }
      })
     
    }
  }
};
</script>

<style lang="less">
#login {
  display: flex;position: absolute;top:0;left:0;right:0;bottom:0;
  .lleft {
    background:#F4F8FC;flex:4;height:100%;display:flex;justify-content: center;align-items:center; flex-direction:  column;
    .logo {margin-bottom:100px;
      font-size: 18px;text-align:center;height:calc(100% - 200px);display:flex;justify-content: center;align-items:center; flex-direction:  column;
      img {width:140px;margin-bottom:20px;cursor: pointer;}
    }
    .copy {color:#7A7A7A;font-size:14px;text-align: center;}
  }
  .lright {
    flex:6;border-left:1px solid #D1D1D1;height:100%;display:flex;justify-content: center;align-items:center;
    .rightbox {
      width:460px;display:flex;justify-content: center;flex-direction:  column;text-align: left;
    }
    .tit {
      font-size:24px;font-weight: bold;
    }
    .dlfont {font-size:18px;font-weight: bold}
    .inp {width:100%;;margin-top:10px;
        .el-input__inner {
          height:50px;font-size:18px;border:1px solid #D3D3D3;
        }
    }
    .logbtn {
      margin-top:50px;
height: 60x;
background: #2397CA;
border-radius: 6px;font-size:22px;
    }
    .linkfont {color:#2397CA;font-weight: bold;font-size: 16px;cursor: pointer;}
  }
  .tipfont {font-size:18px;font-weight: bold}
  .zhmm {
    margin-top:20px;
     .el-input__inner {
          height:50px;font-size:18px;border:1px solid #D3D3D3;font-size:16px;
        }
  }
  .zhmmbtn {
  margin-top:35px;width:100%;
background: #2397CA;
border-radius: 8px;font-size:18px;height:50px;
  }
  .zhmmdiv {padding:50px;}
}
</style>
